(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["savor-the-flavor"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('stf-carousel')) return;
  class StfCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.track = this.querySelector('.stf-track');
      this.cards = Array.from(this.track.children);
      this.prev = this.querySelector('.stf-prev');
      this.next = this.querySelector('.stf-next');
      this.live = this.querySelector('.stf-sr');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.loop = this.dataset.loop === 'true' && this.cards.length > 1;
      this.rtl = getComputedStyle(this).direction === 'rtl';
      this.index = 0;
      this.listen(this.prev, 'click', () => this.move(this.rtl ? 1 : -1));
      this.listen(this.next, 'click', () => this.move(this.rtl ? -1 : 1));
      this.listen(this.track, 'scroll', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.settle(), 160); }, { passive:true });
      this.listen(this.track, 'scrollend', () => this.settle());
      this.listen(this.track, 'keydown', e => {
        if (e.target !== this.track) return;
        const delta = e.key === 'ArrowRight' ? (this.rtl ? -1 : 1) : e.key === 'ArrowLeft' ? (this.rtl ? 1 : -1) : 0;
        if (delta) { e.preventDefault(); this.move(delta); }
        if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); this.go(e.key === 'Home' ? 0 : this.cards.length - 1); }
      });
      this.listen(this.track, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.drag = { id:e.pointerId, x:e.clientX, scroll:this.position(), moved:false };
      });
      this.listen(window, 'pointermove', e => {
        if (!this.drag || e.pointerId !== this.drag.id) return;
        const distance = e.clientX - this.drag.x;
        if (Math.abs(distance) > 5 && !this.drag.moved) {
          this.drag.moved = true;
          this.track.dataset.dragging = '';
          this.track.setPointerCapture(e.pointerId);
        }
        if (this.drag.moved) { e.preventDefault(); this.setPosition(this.drag.scroll - distance * (this.rtl ? -1 : 1), 'instant'); }
      }, { passive:false });
      const release = () => {
        if (!this.drag) return;
        const moved = this.drag.moved;
        this.drag = null;
        delete this.track.dataset.dragging;
        if (moved) {
          this.suppressClick = true;
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 100);
          this.go(Math.round((this.position() - this.base) / this.step));
        }
      };
      this.listen(window, 'pointerup', release);
      this.listen(window, 'pointercancel', release);
      this.listen(this.track, 'dragstart', e => e.preventDefault());
      this.listen(this.track, 'click', e => { if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); } }, { capture:true });
      this.listen(document, 'shopify:block:select', e => {
        const index = this.cards.findIndex(card => card.dataset.blockId === e.detail.blockId);
        if (index >= 0) this.go(index, true);
      });
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        if (!video) return;
        const play = () => { if (!this.reduced.matches) video.play().then(() => { if (card.matches(':hover') || card.contains(document.activeElement)) card.dataset.videoPlaying = ''; else video.pause(); }).catch(() => {}); };
        const pause = () => { if (card.contains(document.activeElement)) return; video.pause(); delete card.dataset.videoPlaying; };
        this.listen(card, 'pointerenter', play);
        this.listen(card, 'focusin', play);
        this.listen(card, 'pointerleave', pause);
        this.listen(card, 'focusout', () => queueMicrotask(pause));
      });
      this.listen(this.reduced, 'change', () => { if (this.reduced.matches) this.cards.forEach(c => { c.querySelector('video')?.pause(); delete c.dataset.videoPlaying; }); });
      this.observer = new ResizeObserver(() => {
        if (this.lastWidth === this.track.clientWidth) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      });
      this.observer.observe(this.track);
      this.measure();
    }
    listen(target, event, callback, options = {}) { target?.addEventListener(event, callback, { ...options, signal:this.abort.signal }); }
    position() { return this.track.scrollLeft * (this.rtl ? -1 : 1); }
    setPosition(left, behavior) { this.track.scrollTo({ left:left * (this.rtl ? -1 : 1), behavior }); }
    measure() {
      if (!this.cards.length || !this.track.clientWidth) return;
      this.lastWidth = this.track.clientWidth;
      const style = getComputedStyle(this.track);
      const width = this.cards[0].getBoundingClientRect().width;
      this.step = width + parseFloat(style.columnGap);
      this.inset = parseFloat(style.scrollPaddingInlineStart) || 0;
      this.padding = parseFloat(style.paddingInlineStart) || 0;
      let cloneCount = this.cloneCount || 0;
      if (this.loop && !this.clonesBuilt) {
        cloneCount = Math.max(this.cards.length, 8);
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        const clone = card => {
          const copy = card.cloneNode(true);
          copy.dataset.stfClone = '';
          copy.setAttribute('aria-hidden','true');
          copy.inert = true;
          [copy, ...copy.querySelectorAll('*')].forEach(el => { el.removeAttribute('id'); el.removeAttribute('data-shopify-editor-block'); el.removeAttribute('data-block-id'); });
          copy.querySelectorAll('video').forEach(v => v.remove());
          copy.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
          return copy;
        };
        for (let i = -cloneCount; i < 0; i++) before.append(clone(this.cards[(i % this.cards.length + this.cards.length) % this.cards.length]));
        for (let i = 0; i < cloneCount; i++) after.append(clone(this.cards[i % this.cards.length]));
        this.track.prepend(before);
        this.track.append(after);
        this.cloneCount = cloneCount;
        this.clonesBuilt = true;
      }
      this.base = cloneCount * this.step + this.padding - this.inset;
      this.jump(this.base + this.index * this.step);
      this.update();
    }
    jump(value) {
      this.track.dataset.jumping = '';
      this.setPosition(value, 'instant');
      cancelAnimationFrame(this.jumpFrame);
      this.jumpFrame = requestAnimationFrame(() => { delete this.track.dataset.jumping; });
    }
    go(index, instant = false) {
      if (!this.step) return;
      if (!this.loop) index = Math.max(0, Math.min(this.cards.length - 1, index));
      this.setPosition(this.base + index * this.step, instant || this.reduced.matches ? 'instant' : 'smooth');
    }
    move(delta) {
      if (!this.step) return;
      const index = Math.round((this.position() - this.base) / this.step);
      this.go(index + delta);
    }
    settle() {
      if (!this.step || this.drag || this.track.hasAttribute('data-jumping')) return;
      clearTimeout(this.timer);
      const raw = (this.position() - this.base) / this.step;
      const nearest = Math.round(raw);
      const normalized = ((nearest % this.cards.length) + this.cards.length) % this.cards.length;
      this.index = this.loop ? normalized : Math.max(0, Math.min(this.cards.length - 1, nearest));
      if (this.loop && (nearest < 0 || nearest >= this.cards.length)) this.jump(this.position() + (normalized - nearest) * this.step);
      this.update();
    }
    update() {
      const start = !this.loop && this.position() <= 1;
      const end = !this.loop && this.position() >= this.track.scrollWidth - this.track.clientWidth - 1;
      [[this.prev,this.rtl ? end : start],[this.next,this.rtl ? start : end]].forEach(([button,disabled]) => { if (button) { button.disabled = disabled; button.setAttribute('aria-disabled',String(disabled)); } });
      if (this.live && this.cards.length) this.live.textContent = this.live.dataset.announcement.replace('[index]',this.index + 1).replace('[count]',this.cards.length);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.observer?.disconnect();
      clearTimeout(this.timer); clearTimeout(this.clickTimer); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.jumpFrame);
      this.track?.querySelectorAll('[data-stf-clone]').forEach(c => c.remove());
      this.clonesBuilt = false; this.cloneCount = 0;
      this.cards?.forEach(c => c.querySelector('video')?.pause());
    }
  }
  customElements.define('stf-carousel',StfCarousel);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('stf-carousel').forEach(el => el.connectedCallback()));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('stf-carousel').forEach(el => el.disconnectedCallback()));
})();

  } catch(e) { console.error(e); }
})();
})();
